import "./dropDown.css";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

const CustomerDropDownSelector = ({
  headerText,
  ddData,
  customerId,
  setCustomerId,
}) => {
  // Find the selected customer for initial selection
  const selectedCustomer = ddData?.find(
    (c) => String(c.CustomerNo) === String(customerId)
  );

  return (
    <div className="admin-dropdown-container">
      <label className="admin-dropdown-label">{headerText}</label>
      <Typeahead
        id="customer-typeahead"
        onChange={(selected) => {
          if (selected.length > 0) {
            setCustomerId(String(selected[0].CustomerNo));
          } else {
            setCustomerId("NA");
          }
        }}
        options={ddData || []}
        labelKey={(option) => `${option.CustomerName} - ${option.CustomerNo}`}
        placeholder="Välj kund..."
        selected={selectedCustomer ? [selectedCustomer] : []}
      />
    </div>
  );
};

export default CustomerDropDownSelector;
